import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ErrorBoundary } from '@/components/common';
import { AppRoutes } from '@/routes';
import { useThemeStore } from '@/store/themeStore';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const { theme } = useThemeStore();

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme={theme === 'dark' ? 'dark' : 'light'}
        />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
